import { render, staticRenderFns } from "./StudentClass.vue?vue&type=template&id=e5102706&scoped=true"
import script from "./StudentClass.vue?vue&type=script&lang=js"
export * from "./StudentClass.vue?vue&type=script&lang=js"
import style0 from "./StudentClass.vue?vue&type=style&index=0&id=e5102706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5102706",
  null
  
)

export default component.exports